import _defineProperty from "/runner/_work/miro-site/miro-site/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";
import _objectWithoutProperties from "/runner/_work/miro-site/miro-site/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/objectWithoutProperties.js";
var _excluded = ["as", "children", "renderChildrenAsHTML"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import React from 'react';
import { jsx as _jsx } from "react/jsx-runtime";

var Text = function Text(_ref) {
  var _ref$as = _ref.as,
      as = _ref$as === void 0 ? 'span' : _ref$as,
      children = _ref.children,
      renderChildrenAsHTML = _ref.renderChildrenAsHTML,
      rest = _objectWithoutProperties(_ref, _excluded);

  var Element = as;

  var getContent = function getContent() {
    if (!renderChildrenAsHTML) {
      return children;
    }

    if (typeof children !== 'string') {
      throw Error('You can only use `renderChildrenAsHTML` if the children is a `string`.');
    }

    return /*#__PURE__*/_jsx("span", {
      dangerouslySetInnerHTML: {
        __html: children
      }
    });
  };

  return /*#__PURE__*/_jsx(Element, _objectSpread(_objectSpread({}, rest), {}, {
    children: getContent()
  }));
};

export default Text;